"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date("2026-08-08T12:30:00").getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance > 0) {
        setTimeRemaining({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      } else {
        setTimeRemaining({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const timerBlocks = [{
    value: timeRemaining.days,
    label: "Días",
    color: "bg-primary"
  }, {
    value: timeRemaining.hours,
    label: "Horas",
    color: "bg-primary"
  }, {
    value: timeRemaining.minutes,
    label: "Minutos",
    color: "bg-primary"
  }, {
    value: timeRemaining.seconds,
    label: "Segundos",
    color: "bg-primary"
  }];
  return <section id="hero" className="relative min-h-screen w-full bg-cover bg-center bg-[url(https://ideal-ray.10web.cloud/wp-content/uploads/2026/02/IMG-20260210-WA0011.jpg)]">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/40 via-secondary/20 to-accent-dark/30 pointer-events-none" />

      {}
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-[var(--space-xl)] py-[var(--space-xl)] md:py-[var(--space-4xl)]">
        <div ref={contentRef} className={`text-center max-w-4xl transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[1rem]"}`}>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-white leading-[1.2] mb-[var(--space-xl)] drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]">
            Lucía &amp; Kike
          </h1>
          
          <p className="text-[1.5rem] md:text-[2rem] font-light text-white/95 mb-[var(--space-xl)] drop-shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
            8 de agosto de 2026
          </p>

          <p className="text-[1.25rem] md:text-[1.5rem] font-light text-white/95 mb-[var(--space-2xl)] drop-shadow-[0_2px_8px_rgba(0,0,0,0.3)] italic">
            Donde se acaba el mar y donde empieza nuestra historia
          </p>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 md:bottom-12 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-4">
        <Button className="btn-primary text-lg px-8 py-6 shadow-strong hover:scale-105 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]" asChild>
          <Link to="#confirmar-asistencia">Confirmar Asistencia</Link>
        </Button>

        {}
        <div className="inline-flex gap-1.5 md:gap-2">
          {timerBlocks.map((block, i) => <div key={i} data-index={i} className={`${block.color} text-white rounded-lg px-2 py-3 md:px-3 md:py-4 shadow-strong backdrop-blur-sm bg-opacity-90 hover:scale-105 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]`}>
              <div className="text-xl md:text-2xl font-bold font-display leading-none mb-1">
                {block.value.toString().padStart(2, "0")}
              </div>
              <div className="text-[0.625rem] md:text-xs font-medium uppercase tracking-wider opacity-90">
                {block.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}